import { render, staticRenderFns } from "./Pabx.vue?vue&type=template&id=5d5995a7&"
import script from "./Pabx.vue?vue&type=script&lang=js&"
export * from "./Pabx.vue?vue&type=script&lang=js&"
import style0 from "./Pabx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports